module.exports = __webpack_public_path__ + "img/password-changed.4ab2c205.svg";